import React, { useEffect } from "react";
import { Btn2 } from "../common/btn";
import { GatsbyImage } from "gatsby-plugin-image";
import Tilt from "react-parallax-tilt";
const DownloadApp = ({ data }) => {
  const scale = 1.04;
  useEffect(() => {
    // const parallaxInstance = new Parallax(sceneEl.current, {
    //   relativeInput: true,
    // });
    // parallaxInstance.enable();
    // return () => parallaxInstance.disable();
  }, []);

  return (
    <div
      className="w-full px-5 sm:px-10 py-5 sm:py-10 bg-[#dfdfdf] min-h-[400px] relative h-full"
      id={data.sectionId}
    >
      <div className="max-w-7xl w-full h-full mx-auto text-center">
        <div className="grid md:grid-cols-2 items-center justify-center gap-12 h-full">
          {/* App Screenshot */}
          <div className="w-full relative h-full block">
            <div className="absolute top-1/2 -translate-y-1/2 left-0 w-3/5 h-auto float-left">
              <Tilt scale={1.06} transitionSpeed={4000} className="relative">
                <GatsbyImage
                  image={data.image.asset.gatsbyImageData}
                  alt={data.image.alt}
                  objectFit="contain"
                  className="w-full mx-auto object-contain rounded-3xl"
                />
              </Tilt>
            </div>
            <div className="relative top-0 right-11 w-3/5 h-full float-right z-[2]">
              <Tilt scale={scale} transitionSpeed={4000}>
                <GatsbyImage
                  image={data.image2.asset.gatsbyImageData}
                  alt={data.image2.alt}
                  objectFit="contain"
                  className="w-full mx-auto object-contain rounded-3xl"
                />
              </Tilt>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-3 flex flex-col items-center">
            <h2 className="text-2xl sm:text-4xl font-bold text-black flex items-center justify-center">
              {data.leftIcon && (
                <img
                  src={data.leftIcon.asset.url || "/placeholder.svg"}
                  alt=""
                  className="w-9 sm:w-12 h-9 sm:h-12 mr-2 object-contain"
                />
              )}
              {data.title}
              {data.rightIcon && (
                <img
                  src={data.rightIcon.asset.url || "/placeholder.svg"}
                  alt=""
                  className="w-9 sm:w-12 h-9 sm:h-12 ml-2 object-contain"
                />
              )}
            </h2>
            <p className="text-black text-lg sm:text-xl max-w-3xl mx-auto">
              {data.subTitle}
            </p>

            <div className="flex flex-wrap gap-4 justify-center">
              <Btn2 data={data.button} />
              <Btn2 data={data.button2} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadApp;
